<template>
  <div>
    <!-- homepage header -->
    <header id="home-header" class="home-header">
      <!-- header content -->
      <div class="home-header__title">
        <div class="home-header__title-logo">
          <img src="@/assets/images/logo.png" alt="Adele Angel" />
        </div>
        <div class="home-header__title-intro">
          <h2>
            Hello, my name is
            <span>Adele</span>
          </h2>
        </div>
        <div class="home-header__title-content">
          <h1>
            And I'm a
            <span>Full Stack Developer</span>
          </h1>
        </div>
      </div>

      <!-- scroll down button -->
      <div class="smoothscroll">
        <a href="#projects">
          <div class="scroll-down"></div>
        </a>
      </div>
    </header>

    <!-- navigation -->
    <Navbar />
  </div>
</template>

<script>
import Navbar from "@/components/globals/Navbar";

export default {
  name: "HomeHeader",
  components: {
    Navbar
  }
};
</script>
